import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('users.header'),
      path: 'configurations/users',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/users/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('groups.groups_link'),
          path: 'configurations/users/groups',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('companies.companies_link'),
          path: 'configurations/users/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('configurations.status_link'),
          path: 'configurations/users/status',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('agenda.seller_link'),
          path: 'configurations/users/providercompany',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        // {
        //   name: 'Configuración dashboard',
        //   path: 'configurations/users/dashboardconfig',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // },
        {
          name: i18n.t('historical.entity_name'),
          path: 'configurations/users/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
